/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * CatalogForm.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {CatalogDTO} from "../../dto/catalog/CatalogDTO";

export default class CatalogForm extends AbstractForm<CatalogDTO> {

    constructor(dto?: CatalogDTO) {
        super();

        this.fields.set(CatalogDTO.TITLE, new TextField(
            CatalogDTO.TITLE,
            (t: Translation) => "Titre",
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        if (dto) super.load(dto);
    }
}
